export enum TerritoryRouteTypeEnum {
    Furia_Roja = 'FR',
    Preventa = 'P',
    Reparto = 'REP',
    LM = 'LM',
    AUT_FORANEA = 'AUT FORANEA',
    AUT_LOCAL = 'AUT LOCAL',
    RETAIL = 'RETAIL',
}

export enum TerritoryRouteTypeAcronymDisplayEnum {
    FR = 'Furia Roja',
    P = 'Preventa',
    REP = 'Reparto',
    LM = 'LM',
    AUT_FORANEA = 'AUT FORANEA',
    AUT_LOCAL = 'AUT LOCAL',
    RETAIL = 'RETAIL',
}

export enum TerritoryRouteTypeColorsEnum {
    Furia_Roja = '#ff6a6a',
    Preventa = '#90EE90',
    Reparto = '#c2a1ff',
    LM = '#c2f0ff',
    AUT_FORANEA = '#ffcfbb',
    AUT_LOCAL = '#82f3ed',
    RETAIL = '#ee7fe8',
}

export enum TerritoryRouteTypeIconsEnum {
    Furia_Roja = 'territory_fr.png',
    Preventa = 'territory_preventa.png',
    Reparto = 'territory_reparto.png',
    LM = 'territory_default.png',
    AUT_FORANEA = 'territory_aut_foranea.png',
    AUT_LOCAL = 'territory_aut_local.png',
    RETAIL = 'territory_retail.png',
}


export enum TerritoryFrequencyEnum {
    M1 = 'M1',
    M2 = 'M2',
    M3 = 'M3',
    M4 = 'M4',
    Q1 = 'Q1',
    Q2 = 'Q2',
    S1 = 'S1',
    S2 = 'S2',
    S3 = 'S3',
    S4 = 'S4',
}

export enum TerritoryFrequencyColorsEnum {
    M1 = '#ffcccb',
    M2 = '#a3ffa3',
    M3 = '#85fff5',
    M4 = '#fbff19',
    Q1 = '#ffb0eb',
    Q2 = '#eda4ff',
    S1 = '#ffcccb',
    S2 = '#a3ffa3',
    S3 = '#85fff5',
    S4 = '#fbff19',
}

export enum TerritorySaturationEnum {
    Baja = 'baja',
    Media = 'media',
    Alta = 'alta'
}

export enum TerritorySaturationColorsEnum {
    Alta = '#830000',
    Media = '#9b8b00',
    Baja = '#0b8300'
}